import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, MailIcon, ClockIcon, MapPinIcon, SendIcon, MessageCircleIcon } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function ContactSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  const [formData, setFormData] = useState({
    nombre: '',
    empresa: '',
    telefono: '',
    vehiculos: '',
    tipoVehiculo: '',
    plan: '',
    mensaje: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section id="contacto" ref={ref} className="w-full bg-brand-bg py-20 md:py-28" data-id="element-13">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-12 md:mb-16" data-id="element-15">
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-white mb-4" data-id="element-16">
            Solicita tu cotización personalizada
          </h2>
          <p className="font-body text-lg text-brand-text-secondary max-w-2xl mx-auto" data-id="element-17">
            Sin compromiso. Te respondemos en menos de 2 horas.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-5 gap-8 lg:gap-12" data-id="element-18">
          {/* Form */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isVisible ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-3" data-id="element-19">
            <form onSubmit={handleSubmit} className="glass-strong rounded-2xl p-6 md:p-8" data-id="element-20">
              <div className="grid md:grid-cols-2 gap-6" data-id="element-21">
                {/* Nombre */}
                <div data-id="element-22">
                  <label htmlFor="nombre" className="block font-subheading text-sm text-white mb-2" data-id="element-23">
                    Nombre completo *
                  </label>
                  <input type="text" id="nombre" name="nombre" required value={formData.nombre} onChange={handleChange} className="w-full bg-brand-bg border border-cyan-subtle rounded-lg px-4 py-3 font-body text-white placeholder-brand-text-secondary/50 focus:outline-none focus:border-brand-accent focus:ring-1 focus:ring-brand-accent transition-colors" placeholder="Tu nombre" data-id="element-24" />
                </div>

                {/* Empresa */}
                <div data-id="element-25">
                  <label htmlFor="empresa" className="block font-subheading text-sm text-white mb-2" data-id="element-26">
                    Empresa (opcional)
                  </label>
                  <input type="text" id="empresa" name="empresa" value={formData.empresa} onChange={handleChange} className="w-full bg-brand-bg border border-cyan-subtle rounded-lg px-4 py-3 font-body text-white placeholder-brand-text-secondary/50 focus:outline-none focus:border-brand-accent focus:ring-1 focus:ring-brand-accent transition-colors" placeholder="Nombre de tu empresa" data-id="element-27" />
                </div>

                {/* Teléfono */}
                <div data-id="element-28">
                  <label htmlFor="telefono" className="block font-subheading text-sm text-white mb-2" data-id="element-29">
                    Teléfono / WhatsApp *
                  </label>
                  <input type="tel" id="telefono" name="telefono" required value={formData.telefono} onChange={handleChange} className="w-full bg-brand-bg border border-cyan-subtle rounded-lg px-4 py-3 font-body text-white placeholder-brand-text-secondary/50 focus:outline-none focus:border-brand-accent focus:ring-1 focus:ring-brand-accent transition-colors" placeholder="55 1234 5678" data-id="element-30" />
                </div>

                {/* Número de vehículos */}
                <div data-id="element-31">
                  <label htmlFor="vehiculos" className="block font-subheading text-sm text-white mb-2" data-id="element-32">
                    Número de vehículos *
                  </label>
                  <select id="vehiculos" name="vehiculos" required value={formData.vehiculos} onChange={handleChange} className="w-full bg-brand-bg border border-cyan-subtle rounded-lg px-4 py-3 font-body text-white focus:outline-none focus:border-brand-accent focus:ring-1 focus:ring-brand-accent transition-colors appearance-none cursor-pointer" data-id="element-33">
                    <option value="" data-id="element-34">Selecciona</option>
                    <option value="1" data-id="element-35">1 vehículo</option>
                    <option value="2-5" data-id="element-36">2 - 5 vehículos</option>
                    <option value="6-20" data-id="element-37">6 - 20 vehículos</option>
                    <option value="21-50" data-id="element-38">21 - 50 vehículos</option>
                    <option value="50+" data-id="element-39">Más de 50 vehículos</option>
                  </select>
                </div>

                {/* Tipo de vehículo */}
                <div data-id="element-40">
                  <label htmlFor="tipoVehiculo" className="block font-subheading text-sm text-white mb-2" data-id="element-41">
                    Tipo de vehículo *
                  </label>
                  <select id="tipoVehiculo" name="tipoVehiculo" required value={formData.tipoVehiculo} onChange={handleChange} className="w-full bg-brand-bg border border-cyan-subtle rounded-lg px-4 py-3 font-body text-white focus:outline-none focus:border-brand-accent focus:ring-1 focus:ring-brand-accent transition-colors appearance-none cursor-pointer" data-id="element-42">
                    <option value="" data-id="element-43">Selecciona</option>
                    <option value="auto" data-id="element-44">Auto particular</option>
                    <option value="moto" data-id="element-45">Motocicleta</option>
                    <option value="camion" data-id="element-46">Camión / Transporte de carga</option>
                    <option value="flotilla" data-id="element-47">Flotilla mixta</option>
                  </select>
                </div>

                {/* Plan de interés */}
                <div data-id="element-48">
                  <label htmlFor="plan" className="block font-subheading text-sm text-white mb-2" data-id="element-49">
                    Plan de interés
                  </label>
                  <select id="plan" name="plan" value={formData.plan} onChange={handleChange} className="w-full bg-brand-bg border border-cyan-subtle rounded-lg px-4 py-3 font-body text-white focus:outline-none focus:border-brand-accent focus:ring-1 focus:ring-brand-accent transition-colors appearance-none cursor-pointer" data-id="element-50">
                    <option value="" data-id="element-51">Selecciona</option>
                    <option value="basico" data-id="element-52">Plan Básico</option>
                    <option value="intermedio" data-id="element-53">Plan Intermedio</option>
                    <option value="avanzado" data-id="element-54">Plan Avanzado</option>
                    <option value="asesoria" data-id="element-55">No sé, necesito asesoría</option>
                  </select>
                </div>
              </div>

              {/* Mensaje */}
              <div className="mt-6" data-id="element-56">
                <label htmlFor="mensaje" className="block font-subheading text-sm text-white mb-2" data-id="element-57">
                  Mensaje adicional
                </label>
                <textarea id="mensaje" name="mensaje" rows={4} value={formData.mensaje} onChange={handleChange} className="w-full bg-brand-bg border border-cyan-subtle rounded-lg px-4 py-3 font-body text-white placeholder-brand-text-secondary/50 focus:outline-none focus:border-brand-accent focus:ring-1 focus:ring-brand-accent transition-colors resize-none" placeholder="Cuéntanos más sobre tus necesidades..." data-id="element-58" />
              </div>

              {/* Submit */}
              <button type="submit" className="w-full mt-6 bg-brand-accent text-brand-bg font-subheading font-semibold py-4 rounded-lg hover:bg-brand-accent/90 transition-all duration-200 hover:shadow-xl hover:shadow-brand-accent/25 flex items-center justify-center gap-2" data-id="element-59">
                <SendIcon className="w-5 h-5" data-id="element-60" />
                Solicitar Cotización
              </button>
            </form>
          </motion.div>

          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isVisible ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="lg:col-span-2" data-id="element-61">
            <div className="glass rounded-2xl p-6 md:p-8 h-full" data-id="element-62">
              <h3 className="font-heading font-bold text-xl text-white mb-6" data-id="element-63">
                Contacto Directo
              </h3>

              <div className="space-y-6" data-id="element-64">
                {/* Phone */}
                <a href="tel:+525512345678" className="flex items-center gap-4 p-4 bg-brand-bg rounded-xl border border-cyan-subtle hover:border-brand-accent/50 transition-colors group" data-id="element-65">
                  <div className="w-12 h-12 rounded-lg bg-brand-accent/10 flex items-center justify-center group-hover:bg-brand-accent/20 transition-colors" data-id="element-66">
                    <PhoneIcon className="w-6 h-6 text-brand-accent" data-id="element-67" />
                  </div>
                  <div data-id="element-68">
                    <p className="font-subheading text-sm text-brand-text-secondary" data-id="element-69">
                      Teléfono
                    </p>
                    <p className="font-body text-white" data-id="element-70">+52 55 1234 5678</p>
                  </div>
                </a>

                {/* WhatsApp */}
                <a href="https://wa.me/525512345678" target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 p-4 bg-brand-bg rounded-xl border border-cyan-subtle hover:border-brand-accent/50 transition-colors group" data-id="element-71">
                  <div className="w-12 h-12 rounded-lg bg-brand-accent/10 flex items-center justify-center group-hover:bg-brand-accent/20 transition-colors" data-id="element-72">
                    <MessageCircleIcon className="w-6 h-6 text-brand-accent" data-id="element-73" />
                  </div>
                  <div className="flex items-center gap-2" data-id="element-74">
                    <div data-id="element-75">
                      <p className="font-subheading text-sm text-brand-text-secondary" data-id="element-76">
                        WhatsApp
                      </p>
                      <p className="font-body text-white" data-id="element-77">+52 55 1234 5678</p>
                    </div>
                    <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-78" />
                  </div>
                </a>

                {/* Email */}
                <a href="mailto:contacto@trackerspacemx.com" className="flex items-center gap-4 p-4 bg-brand-bg rounded-xl border border-cyan-subtle hover:border-brand-accent/50 transition-colors group" data-id="element-79">
                  <div className="w-12 h-12 rounded-lg bg-brand-accent/10 flex items-center justify-center group-hover:bg-brand-accent/20 transition-colors" data-id="element-80">
                    <MailIcon className="w-6 h-6 text-brand-accent" data-id="element-81" />
                  </div>
                  <div data-id="element-82">
                    <p className="font-subheading text-sm text-brand-text-secondary" data-id="element-83">
                      Email
                    </p>
                    <p className="font-body text-white" data-id="element-84">
                      contacto@trackerspacemx.com
                    </p>
                  </div>
                </a>
              </div>

              {/* Response Time */}
              <div className="mt-8 p-4 bg-brand-accent/10 rounded-xl border border-brand-accent/20" data-id="element-85">
                <div className="flex items-center gap-3 mb-2" data-id="element-86">
                  <ClockIcon className="w-5 h-5 text-brand-accent" data-id="element-87" />
                  <span className="font-subheading font-medium text-white" data-id="element-88">
                    Tiempo de respuesta promedio
                  </span>
                </div>
                <p className="font-heading text-2xl text-brand-accent" data-id="element-89">
                  1.5 horas
                </p>
              </div>

              {/* Coverage */}
              <div className="mt-6 p-4 bg-brand-surface/50 rounded-xl" data-id="element-90">
                <div className="flex items-center gap-3 mb-3" data-id="element-91">
                  <MapPinIcon className="w-5 h-5 text-brand-accent" data-id="element-92" />
                  <span className="font-subheading font-medium text-white" data-id="element-93">
                    Cobertura Nacional
                  </span>
                </div>
                <p className="font-body text-sm text-brand-text-secondary mb-4" data-id="element-94">
                  Instalación disponible en toda la República Mexicana
                </p>
                {/* Mexico Map Silhouette */}
                <div className="relative h-24 opacity-30" data-id="element-95">
                  <svg viewBox="0 0 200 120" className="w-full h-full" data-id="element-96">
                    <path d="M30,20 L50,15 L80,10 L120,15 L150,25 L170,35 L180,50 L175,70 L160,85 L140,95 L110,100 L80,95 L50,85 L30,70 L20,50 L25,35 Z" fill="none" stroke="#00c8ff" strokeWidth="1.5" data-id="element-97" />
                    {/* Glowing dot */}
                    <circle cx="100" cy="55" r="4" fill="#00c8ff" className="animate-pulse" data-id="element-98" />
                  </svg>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}